import {TFunction} from 'i18next';
import {CarePlanConfigurationFeature} from '../../../../../../backend/enums/care-plan-configuration-feature';
import {RowData} from '../../base/export-care-plan-group-data-processor';
import {ExportCarePlanData} from '../../base/export-care-plan-types';
import {CommonIadlPdfDataProcessor} from '../export-care-plan-common-iadl-pdf-data';

export class TransportPdfDataProcessor extends CommonIadlPdfDataProcessor {
  // Inherits the same headers and row structure as Common processor.

  constructor(baseData: ExportCarePlanData, t: TFunction) {
    super(baseData, t);

    this.handleTaskDetailsCellValue = (rowData: RowData) => {
      const responsibleEntry = rowData.getEntryByFeature(
        CarePlanConfigurationFeature.TransportationCollectionBy
      );
      const pickupAddressEntry = rowData.getEntryByFeature(
        CarePlanConfigurationFeature.TransportationCollectionAddress
      );
      const dropoffAddressEntry = rowData.getEntryByFeature(
        CarePlanConfigurationFeature.TransportationDeliveryAddress
      );

      const responsibleName = `<b>${responsibleEntry?.name ?? 'n/a'}:</b>`;
      const transportValue = this.getEntryValue(responsibleEntry) || '-';
      const pickupAddressName = `<b>${pickupAddressEntry?.name ?? 'n/a'}:</b>`;
      const pickupAddressValue = this.getEntryValue(pickupAddressEntry) || '-';
      const dropoffAddressName = `<b>${dropoffAddressEntry?.name ?? 'n/a'}:</b>`;
      const dropoffAddressValue = this.getEntryValue(dropoffAddressEntry) || '-';

      return `${responsibleName}\n${transportValue}\n<br>${pickupAddressName}\n${pickupAddressValue}\n<br>${dropoffAddressName}\n${dropoffAddressValue}`;
    };
  }
}
